<nav
  class="navbar navbar-dark"
  [attr.aria-label]="ariaLabel()"
  [attr.data-cy]="dataCy()"
>
  <div
    class="navbar-container"
    [class.navbar-container-center-brand]="centerLogo()"
  >
    <div class="navbar-brand">
      <ps-link [route]="'/'" [contentType]="'image'">
        <ps-logo
          class="p-1"
          [variant]="logoVariant()"
          [color]="logoColor()"
          [size]="logoSize()"
        />
      </ps-link>
    </div>
    @if (!centerLogo()) {
      <div class="navbar-content">
        <ng-content />
      </div>
    }
  </div>
</nav>
